import { render, staticRenderFns } from "./ConfirmPriceChangeModal.vue?vue&type=template&id=14bf0884"
import script from "./ConfirmPriceChangeModal.vue?vue&type=script&lang=js"
export * from "./ConfirmPriceChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports